import { render, staticRenderFns } from "./BulkRecordOperations.vue?vue&type=template&id=18c67247&scoped=true"
import script from "./BulkRecordOperations.vue?vue&type=script&lang=js"
export * from "./BulkRecordOperations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c67247",
  null
  
)

export default component.exports